import API from "../../../Common/Network/API";
import Alert from "../../../Common/Alert";
import { addCommentUserStory } from "./addCommentUserStory";

export async function updateUserStory(getUser,userStoryId,handleClose,message) {
  try {
    const response = await API.post(
      "manage_userstories.php",
      {
        action: "update",
        task_id: userStoryId,
        crop: getUser.corp,
        task_status: 100,
        task_status_desc: "completed",
        task_complete_status: 1,
        empId: getUser.empId,
      },
      {},
      false
    );
    if (response.status === "True") {
      addCommentUserStory(getUser, userStoryId, message, "2");
    } else {
      Alert("warning", response.message);
    }
  } catch (error) {
    Alert("error", error.message);
  }
  handleClose();
}